/*
module.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
/**
 * @ngdoc object
 * @name UAF Application Shell Module
 * @description This is the main module of the application shell.
 * @requires $translateProvider
 * @requires $translatePartialLoaderProvider
 * @requires AppConfigProvider
 * @requires $SystemConfigProvider
 * @requires $LayoutConfigProvider
 * @requires $stateProvider
 * @requires $urlRouteProvider
 */
define('modules/shell/module',[
    'jquery',
    'lodash',
    'angular',
    'system-config',
    './services/system-language.service',
    './widgets/datepicker/i18n/translations',
    'angular-sanitize',
    'uiRouter',
    'angularTranslate',
    'angularTranslatePartialLoader',
    'angular-translate-loader-pluggable',
    'angular-ui',
    'ngCookies',
    'postal',

    './hdx/components/hdx-bootstrap/js/hdx-bootstrap',

    './widgets/angular-locale/load-angular-locale',
    './widgets/datagrid/js/directive/hdx-datagrid-directive',
    './widgets/content-banner/js/directive/hdx-content-banner-directive',
    './widgets/header/js/directive/hdx-header-directive',
    './widgets/patient-banner/js/directive/hdx-patient-banner-directive',
    './widgets/vertical-menu/vertical-menu.directive',
    './widgets/datepicker/ge-datepicker',
    './widgets/modals/js/services/hdx-modal-service',

    './notification/hc-notification-directive',
    './services/hc-oauth/hc-oauth-module',
    './services/endpoint.service',
    './filters/rtl-filters',
    './filters/date-time-formatters/edlc-date-time-filters'
], function ($, _, angular, systemConfig, systemLanguageService, translations) {
    'use strict';

    $.fn.tooltip = $.fn.btooltip;

    var shell = angular.module('uaf.appshell', [
        'ui.router',
        'pascalprecht.translate',
        'angular-translate-loader-pluggable',
        'headerDirectiveModule',
        'hcOauthModule',
        'hc.Notification.Directive',
        'endpoint',
        'GEVerticalMenu',
        'GeDatePicker',
        'modalAng',
        'rtlFiltersModule',
        'edlcDateTimeFormatters'
    ]);

    shell.factory('i18nPartialLoaderErrorHandler', ['$q', function ($q) {
        return function () {
            return $q.when({});
        };
    }]);

    // Setup internationalization and the default language
    shell.config(['$translateProvider', 'translatePluggableLoaderProvider', function ($translateProvider, translatePluggableLoaderProvider) {

        var supportedMapped = systemLanguageService.supportedLanguages.reduce(function (mapped, lang) {
            mapped[lang + '*'] = lang;
            return mapped;
        }, {});

        $translateProvider.useLoader('translatePluggableLoader');

        translatePluggableLoaderProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/{lang}.json',
            loadFailureHandler: 'i18nPartialLoaderErrorHandler'
        });
        $translateProvider.registerAvailableLanguageKeys(systemLanguageService.supportedLanguages, supportedMapped);
        $translateProvider.fallbackLanguage('en');
        $translateProvider.determinePreferredLanguage(function () {
            return systemLanguageService.getSystemLanguage();
        });
    }]);

    shell.config(['$translatePartialLoaderProvider', function ($translatePartialLoaderProvider) {
        Object.keys(translations).forEach(function (key) {
            $translatePartialLoaderProvider.setPart(key, 'datepicker', translations[key]);
        });
        $translatePartialLoaderProvider.addPart('datepicker');
    }]);

    // Setup default routing
    shell.config(['$urlRouterProvider', '$locationProvider', function ($urlRouterProvider, $locationProvider) {

        if (window.MICRO_APP) {
            $locationProvider.html5Mode(false).hashPrefix('');
        } else {
            $locationProvider.html5Mode(true).hashPrefix('!');
        }

        $urlRouterProvider.when('/login/0', systemConfig.loginUrl);
        $urlRouterProvider.when('/logout/0', systemConfig.logoutUrl);

        $urlRouterProvider.otherwise(function () {
            var next = sessionStorage.getItem('next-screen');
            sessionStorage.removeItem('next-screen');

            if (next) {
                return JSON.parse(next);
            }

            if (systemConfig.defaultRoute) {
                return systemConfig.defaultRoute;
            }

            return '/';
        });

    }]);

    shell.run(['$rootScope', function ($rootScope) {
        var loading = {};

        Object.defineProperty($rootScope, 'preloadingData', {
            configurable: false,
            enumerable: true,
            get: function () {
                return Object.keys(loading).reduce(function (l, key) {
                    return l || loading[key];
                }, false);
            }
        });

        $rootScope.dataLoading = function (key) {
            loading[key] = true;
        };

        $rootScope.dataLoaded = function (key) {
            loading[key] = false;
        };
    }]);

    if (window.C360_APP) {
        shell.run(['tokenService', function (tokenService) {
            tokenService.startRefresh();
        }]);
    }

    return shell;
});

